import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Config } from 'src/app/models/config';
import { OTPTypes } from '../../one-time-password/OTP.model';
import { Source } from '../pdf-viewer.component';

@Injectable({ providedIn: 'root' })
export class PDFViewerService {

  constructor(private http: HttpClient) {
  }

  SaveAgindaDocumentSignature(data) { // Save Configration
    return this.http.post(`${Config.apiUrl}/MeetingAgendaItems/SaveAgindaDocumentSignature/`, data);
  }

  getDocDetails(data, source: Source) {
    if (source == Source.Meetings) {
      return this.http.post(`${Config.apiUrl}/MeetingAgendaItems/GetAgindaDocumentDetails/`, data);
    }
    if (source == Source.Messages) {
      return this.http.post(`${Config.apiUrl}/messages/GetAttachmentDocumentSignetureDetails/`, data);
    }
    if (source == Source.SignDocs) {
      return this.http.post(`${Config.apiUrl}/DocumentsSignature/GetAttachmentDocumentSignetureDetails/`, data);
    }
  }

  RequestOneTimePassword(id, type: OTPTypes) {
    if (type == OTPTypes.MOM) {
      return this.http.get(`${Config.apiUrl}/meetings/RequestFirstOneTimePassword/?meetingId=` + id);
    }
    if (type == OTPTypes.MOMDoc) {
      return this.http.get(`${Config.apiUrl}/MeetingAgendaItems/RequestAgindaDocumentFirstOneTimePassword?documentId=` + id);
    }
    if (type == OTPTypes.MsgDoc) {
      return this.http.get(`${Config.apiUrl}/messages/RequestMessageDocumentFirstOneTimePassword?documentId=` + id);
    }
    if (type == OTPTypes.SignDocs) {
      return this.http.get(`${Config.apiUrl}/DocumentsSignature/RequestDocumentSignatureFirstOneTimePassword?documentId=` + id);
    }
  }
  SubmitMySignature(obj, type: OTPTypes): any {
    if (type == OTPTypes.MOM) {
      return this.http.post(`${Config.apiUrl}/meetings/SubmitMySignature`, obj);
    }
    if (type == OTPTypes.MOMDoc) {
      return this.http.post(`${Config.apiUrl}/MeetingAgendaItems/SubmitMyAgindaDocumentSignature`, obj);
    }
    if (type == OTPTypes.MsgDoc) {
      return this.http.post(`${Config.apiUrl}/messages/SubmitMyMessageDocumentSignature`, obj);
    }
    if (type == OTPTypes.SignDocs) {
      return this.http.post(`${Config.apiUrl}/DocumentsSignature/SubmitMyDocumentSignature`, obj);
    }
  }
}
